module.exports = __webpack_public_path__ + "static/img/isoO.7323a8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/isoO.png
// module id = VdK3
// module chunks = 1